export default {
    title: "Nastavení účtu - DOFFERO®",
    mainucet_text_0: "Nastavení účtu",
    mainucet_text_1:
        "Nastav si základní údaje, které se týkají zejména tvého účtu.",
    mainucet_text_2: "Osobní údaje",
    mainucet_text_3: "Tvoje IP adresy",
    mainucet_text_4:
        "Nastav si IP adresy, ze kterých nebudeme počítat otevření tvé nabídky.",
    mainucet_text_5: "Uložit",
    mainucet_text_6: "Změna hesla",
    mainucet_text_7: "Zrušení účtu",
    mainucet_text_8: "Chceš si zrušit účet na DOFFERO? To nás velmi mrzí.",
    mainucet_text_9: "Napiš mi e-mail na",
    mainucet_text_10: "a účet ti zrušíme co nejdříve.",
    ipaddress_text_0: "Vložit aktuální IP adresu",
    ipaddress_text_1: "IP adresa",
    ipaddress_text_2: "Uložit",
    ipaddress_text_3: "IP adresa byla přidána",
    ipaddress_text_4: "IP adresa byla odstraněna",
    osobneudaje_text_0: "jméno",
    osobneudaje_text_1: "příjmení",
    osobneudaje_text_2: "e-mail",
    osobneudaje_text_3:
        "Registrační e-mail není možné změnit. V případě potřeby mě kontaktuj na",
    osobneudaje_text_4: "help@doffero.com",
    zmenahesla_text_0: "Tvoje aktuální heslo",
    zmenahesla_text_1: "Nové heslo",
    zmenahesla_text_2: "8 znaků",
    zmenahesla_text_3: "1 velké písmeno",
    zmenahesla_text_4: "1 číslice",
    zmenahesla_text_5: "Potvrzení hesla",
    zmenahesla_text_6: "Nová hesla musí být stejná.",
    zmenahesla_text_7: "Změnit heslo",
    // FirstLogin
    first_login_hint:    "Pro dokončení registrace prosím zadej název své firmy, značky nebo podnikání. Na základě toho bude tvá firma přiřazena pod tvůj účet na DOFFERO®. Fakturační údaje si vyplníš později.",
    first_login_ph:      "Název tvé firmy / ZNAČKY",
    first_login_label:   "Název tvé firmy / ZNAČKY",
    first_login_hint2:   "Název tvé firmy / ZNAČKY",

    // ZmenaHesla
    pwd_current_ph:      "Tvoje aktuální heslo",
    pwd_new_ph:          "Nové heslo",
    pwd_confirm_ph:      "Nové heslo ještě jednou",
};